const colors = {
  alabaster: '#cfcfcf',
  black: '#444444',
  gray: '#DDDDDD',
  light_black: '#343B3D',
  light_gray: '#757575',
  dark_red: '#961926',
  monza: '#B5303E',
  dark_monza: '#5a181f',
  red: '#B5303E',
  mantis_green: '#74C022',
  white: '#ffffff',
  silver: '#A8A8A8',
  cream: '#FFFFCC',
  brich: '#312B23',
  blue: '#003FAD',
  blackOpacity: 'rgba(0, 0, 0, 0.05)',
  readOnly: '#ebebe4',
  // inquiry statuses
  NOT_ORDERED: '#ced4da',
  DELIVERED: 'green',
  DELIVERY_FAILED: '#B5303E',
  PENDING_DELIVERY: 'F8E71C',
  ANSWERED_BY_LINK: 'green',
}

export default colors
